import { Tabs } from 'react-bootstrap';

function Tab(props) {
  const { description, ingredient, dosage, warnings } = props;
  return (
    <div className="tabs__container">
      <Tabs defaultActiveKey="Description" id="product__description" className="tabs__container-wrapper">
        <Tab eventKey="Description" title="설명" className="product__tab-wrapper">
          <div className="product__tab-content">
            <div dangerouslySetInnerHTML={ {__html: description}}></div>
          </div>
        </Tab>
        <Tab eventKey="Ingredients" title="성분" className="product__tab-wrapper">
          <div className="product__tab-content">
          <div dangerouslySetInnerHTML={ {__html: ingredient}}></div>
          </div>
        </Tab>
        <Tab eventKey="Dosage" title="복용법" className="product__tab-wrapper">
          <div className="product__tab-content">
          <div dangerouslySetInnerHTML={ {__html: dosage}}></div>
          </div>
        </Tab>
        <Tab eventKey="Warnings" title="주의사항" className="product__tab-wrapper">
          <div className="product__tab-content">
            <div dangerouslySetInnerHTML={ {__html: warnings}}></div>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}

export default Tab;